// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.center-text {
  text-align: center;
  margin-top: 200px;
}

.appbay-link{
  padding-left: 12px;
  font-weight: 500;
}


.popup-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.74); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it overlays everything */
}

.popup-content {
  /* background-color: rgba(255, 255, 255, 0.74); */
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 500px;
  width: 90%;
}

.popup-content h2 {
  margin-top: 0;
}

.popup-content button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.popup-content button:hover {
  background-color: #0056b3;
}

/* Blurred effect for the content when popup is active */
/* .content.blurred {
  filter: blur(5px);
} */


/* 


*/


.popup-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #333333;
  margin-bottom: 15px;
}

.popup-text {
  font-size: 1rem;
  color: #666666;
  margin-bottom: 25px;
}

.popup-button {
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 12px 20px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.popup-button:hover {
  background-color: #0056b3;
}

/* Blurred effect for the content when popup is active */
.content.blurred {
  filter: blur(8px);
  transition: filter 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2CAA2C,EAAE,gCAAgC;EAC7E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;;GAEG;;;AAGH;;;CAGC;;;AAGD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,4BAA4B;AAC9B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.center-text {\n  text-align: center;\n  margin-top: 200px;\n}\n\n.appbay-link{\n  padding-left: 12px;\n  font-weight: 500;\n}\n\n\n.popup-banner {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.74); /* Semi-transparent background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999; /* Ensure it overlays everything */\n}\n\n.popup-content {\n  /* background-color: rgba(255, 255, 255, 0.74); */\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n  max-width: 500px;\n  width: 90%;\n}\n\n.popup-content h2 {\n  margin-top: 0;\n}\n\n.popup-content button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.popup-content button:hover {\n  background-color: #0056b3;\n}\n\n/* Blurred effect for the content when popup is active */\n/* .content.blurred {\n  filter: blur(5px);\n} */\n\n\n/* \n\n\n*/\n\n\n.popup-title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #333333;\n  margin-bottom: 15px;\n}\n\n.popup-text {\n  font-size: 1rem;\n  color: #666666;\n  margin-bottom: 25px;\n}\n\n.popup-button {\n  background-color: #007bff;\n  color: #ffffff;\n  border: none;\n  border-radius: 5px;\n  padding: 12px 20px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.popup-button:hover {\n  background-color: #0056b3;\n}\n\n/* Blurred effect for the content when popup is active */\n.content.blurred {\n  filter: blur(8px);\n  transition: filter 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
